// Copyright 2026, University of Maryland, All Rights Reserved
/**
 * Define reversible organization-role transitions independently from the UI.
 * Delegated admin access must return to ordinary membership when revoked so
 * role editing cannot persist an ambiguous empty authority list.
 */
export function toggleOrganizationRole(roles: readonly string[], role: string): string[] {
  if (role === 'admin') {
    if (roles.includes('admin')) {
      const delegatedRoles = roles.filter(current => current !== 'admin');
      return delegatedRoles.length > 0 ? delegatedRoles : ['member'];
    }
    return ['admin', ...roles.filter(current => current !== 'admin' && current !== 'member')];
  }

  return roles.includes(role)
    ? roles.filter(current => current !== role)
    : [...roles, role];
}
